<template>
  <DSelectButton v-model="selectButton" :options="selectButtonOptions" />
  <div class="h-full min-h-screen overflow-scroll p-4" :class="selectButton">
    <div><Header></Header></div>

    <div class="flex">
      <div class="w-96 p-3">
        <PanelForm title="FormInputSearch">
          <FormInputSearch v-model="searchString"></FormInputSearch>
        </PanelForm>

        <PanelForm title="Tabs">
          <DTabs value="0">
            <DTabList>
              <DTab value="0">Tab 1</DTab>
              <DTab value="1">Tab 2</DTab>
              <DTab value="2">Tab 3</DTab>
            </DTabList>
            <DTabPanels class="p-0">
              <DTabPanel value="0" class="p-4"> Tab 1 Content </DTabPanel>
              <DTabPanel value="1" class="p-4"> Tab 2 Content </DTabPanel>
              <DTabPanel value="2" class="p-4"> Tab 3 Content </DTabPanel>
            </DTabPanels>
          </DTabs>
        </PanelForm>
      </div>
      <div class="w-96 p-3">
        <PanelForm title="SelectionItem">
          <SelectionItem v-for="object in selectionItemObjects" :key="object.uuid" :item="object" />
        </PanelForm>

        <PanelForm title="Empty">
          <div class="flex items-center justify-center text-gray-700">No data to show</div>
        </PanelForm>

        <PanelForm title="CommentItem">
          <CommentItem v-for="object in selectionItemObjects" :key="object.uuid" :item="object" />
        </PanelForm>

        <PanelForm title="BookmarkItem">
          <BookmarkItem v-for="object in selectionItemObjects" :key="object.uuid" :item="object" />
        </PanelForm>
      </div>
      <div class="w-96 p-3">
        <PanelForm title="Form Elements">
          <div class="relative grid grid-cols-7 items-start gap-y-3">
            <div class="col-span-2 mt-2 flex text-gray-400">Icon Button</div>

            <div class="col-span-5 space-x-2">
              <DButton size="small" text icon="pi pi-star" class="text-primary" />
              <DButton size="small" text icon="pi pi-star" />
              <DButton size="small" text icon="pi pi-star" raised />
              <DButton size="small" text icon="pi pi-star" rounded raised />
            </div>

            <div class="col-span-5 col-start-3">
              <DButton size="small" icon="pi pi-sparkles" severity="primary" />
              <DButton size="small" icon="pi pi-sparkles" severity="dark" />
              <DButton size="small" icon="pi pi-sparkles" severity="warn" />
              <DButton size="small" icon="pi pi-sparkles" severity="info" />
              <DButton size="small" icon="pi pi-sparkles" severity="success" />
              <DButton size="small" icon="pi pi-sparkles" severity="danger" />
              <DButton size="small" icon="pi pi-sparkles" severity="contrast" />
            </div>

            <div class="col-span-2 mt-2 flex text-gray-400">Small Button</div>
            <div class="col-span-5">
              <DButton size="small" label="Small Button Text" severity="primary" />
            </div>

            <div class="col-span-2 mt-2 flex text-gray-400">Button</div>
            <div class="col-span-5">
              <DButton label="Button Text" severity="primary" />
            </div>

            <div class="col-span-2 mt-2 flex text-gray-400">Large Button</div>
            <div class="col-span-5">
              <DButton size="large" label="Large Button Text" severity="primary" />
            </div>

            <div class="col-span-2 mt-2 flex text-gray-400">Toggle Switch</div>
            <div class="col-span-5">
              <DToggleSwitch v-model="toggleSwitch" />
            </div>

            <div class="col-span-2 mt-2 flex text-gray-400">Colour Picker</div>
            <div class="col-span-5">
              <DColorPicker />
            </div>

            <div class="col-span-2 mt-2 flex text-gray-400">Slider</div>
            <div class="col-span-5">
              <DSlider v-model="sliderValue" />
            </div>

            <div class="col-span-2 mt-2 flex text-gray-400">Radio Button</div>
            <div class="col-span-5">
              <DRadioGroup :options="radioButtonOptions" v-model="radioOption" />
            </div>

            <div class="col-span-2 mt-2 flex text-gray-400">Input Number</div>
            <div class="col-span-5">
              <DInputNumber />
            </div>

            <div class="col-span-2 mt-2 flex text-gray-400">Input Text</div>
            <div class="col-span-5">
              <DInputText v-model="radioOption" />
            </div>

            <div class="col-span-2 mt-2 flex text-gray-400">Select</div>
            <div class="col-span-5">
              <DSelect :options="radioButtonOptions" v-model="radioOption" optionLabel="label" optionValue="value" />
            </div>
          </div>
        </PanelForm>
      </div>
      <div class="w-96 p-3">
        <PanelForm title="Menus">
          <div class="space-y-3">
            <div @contextmenu="showContextMenu($event)">Right Click for Context Menu</div>

            <!-- <ContextMenu ref="contextMenuRef" /> -->
            <DContextMenu ref="contextMenuRef" :items="contextItems" @select="menuSelected" />
            <!-- menu -->
            <DMenu :model="contextItems">
              <template #item="{ item, props }">
                <a class="flex items-center" v-bind="props.action">
                  <span :class="item.icon" />
                  <span class="ml-2">{{ item.label }}</span>
                </a>
              </template>
            </DMenu>
            <!-- Menu -->
            <DMenuBar :model="contextItems" />
          </div>
        </PanelForm>

        <PanelForm title="Header">
          <div class="space-y-3">
            <DisguiseLogo />
            <Help />
            <OnlineAvatarGroup />
            <OnlineAvatarGroup :currentUsers="currentUsers" />
            <WhatsNew />
          </div>
        </PanelForm>
      </div>

      <div class="w-96 p-3">
        <PanelForm title="Timeline Elements">
          <div class="space-y-4">
            <div class="relative h-10">
              <KeyFrame />
            </div>

            <div class="relative flex h-10">
              <KeyFrameLine
                :style="{
                  left: `0px`,
                  width: `160px`,
                }" />

              <KeyFrame />

              <KeyFrame
                :style="{
                  left: `100px`,
                }" />

              <KeyFrame
                :style="{
                  left: `157px`,
                }" />
            </div>

            <LayerLabel :name="'Layer Name'" :label="'Layer 1'" />

            <Controls />

            <div class="flex gap-12 overflow-hidden">
              <div class="relative h-10">
                <PlayHeadLine :showArrow="true" />
              </div>

              <div class="relative h-10">
                <PlayHeadLine :showArrow="true" />
              </div>

              <div class="relative h-10">
                <PlayHeadLine />
              </div>
            </div>

            <TimelineText :seconds="56" />
          </div>
        </PanelForm>
      </div>
    </div>

    <div class="p-10">
      <PanelForm title="Timeline">
        <div class="sticky top-0 z-20 flex h-10 border-b border-gray-700 bg-[#101828]">
          <div class="w-[235px] shrink-0 p-1">
            <Controls />
          </div>
          <div class="no-scrollbar relative flex-1 overflow-x-scroll overflow-y-hidden select-none">
            <!-- ticks & labels are absolutely‑positioned so the strip itself never scrolls vertically -->
            <div class="relative h-full" :style="{ width: `${timelineLength * pixelsPerSecond}px` }">
              <PlayHeadLine :showArrow="true" :style="{ left: `${playheadPosition}px` }" />

              <template v-for="s in visibleTicks" :key="s">
                <div
                  v-if="shouldShowTick(s)"
                  :style="{ left: `${s * pixelsPerSecond - 3}px` }"
                  class="absolute top-0 flex h-full flex-col items-start">
                  <div :class="['w-px bg-[#475467]', isMajorTick(s) ? 'h-full' : 'h-4', 'translate-x-0.5']"></div>

                  <TimelineText v-if="shouldShowLabel(s)" :seconds="s" />
                </div>
              </template>
            </div>
          </div>
        </div>

        <div class="flex h-full">
          <!-- ◀ left: layers -->
          <div class="no-scrollbar w-[235px] shrink-0 overflow-y-scroll border-r border-gray-700" ref="layersPane">
            <LayerLabel
              v-for="layer in getLayersKeyframes"
              :key="layer.id"
              name="Layer Name"
              :label="layer.key"
              :style="{
                height: `${rowHeight}px`,
              }" />
          </div>

          <!-- ▶ right: timeline tracks -->
          <div ref="timelinePane" class="no-scrollbar relative m-0 flex-1 overflow-scroll">
            <!-- stretchy track wrapper -->
            <div class="relative h-full" :style="{ width: `${timelineLength * pixelsPerSecond}px` }">
              <PlayHeadLine :style="{ left: `${playheadPosition}px` }"> </PlayHeadLine>
              <!-- rows -->
              <div
                v-for="(layer, rowIdx) in getLayersKeyframes"
                :key="layer.id"
                :style="{
                  top: `${rowIdx * rowHeight}px`,
                }"
                class="absolute right-0 left-0 h-16 border-b border-gray-700">
                <!-- Draw line between first and last keyframe -->
                <KeyFrameLine
                  v-if="layer.keyframes.length > 1"
                  :style="{
                    left: `${layer.keyframes[0].time * pixelsPerSecond}px`,
                    width: `${
                      (layer.keyframes[layer.keyframes.length - 1].time - layer.keyframes[0].time) * pixelsPerSecond
                    }px`,
                  }"></KeyFrameLine>
                <!-- paint keyframes -->
                <template v-for="kf in layer.keyframes" :key="kf.id">
                  <KeyFrame
                    :style="{
                      left: `${kf.time * pixelsPerSecond - 7}px`,
                    }"></KeyFrame>
                </template>
              </div>
            </div>
          </div>
        </div>
      </PanelForm>
    </div>

    <div class="p-10">
      <PanelForm title="Table">
        <DDataTable :value="sampleTableData" selectionMode="single" class="w-full" paginator :rows="10">
          <Column field="code" header="Code" sortable></Column>
          <Column field="name" header="Name"></Column>
          <Column field="category" header="Category"></Column>
        </DDataTable>
      </PanelForm>
    </div>
  </div>
</template>

<script setup>
import {
  BookmarkItem,
  CommentItem,
  Controls,
  DisguiseLogo,
  FormInputSearch,
  Header,
  Help,
  KeyFrame,
  KeyFrameLine,
  LayerLabel,
  OnlineAvatarGroup,
  PanelForm,
  PlayHeadLine,
  SelectionItem,
  TimelineText,
  WhatsNew,
} from '@/components';
import { computed, ref } from 'vue';

import {
  DButton,
  DColorPicker,
  DContextMenu,
  DDataTable,
  DInputNumber,
  DInputText,
  DMenu,
  DMenuBar,
  DRadioGroup,
  DSelect,
  DSelectButton,
  DSlider,
  DTab,
  DTabList,
  DTabPanel,
  DTabPanels,
  DTabs,
  DToggleSwitch,
} from '@disguise/cloud-ui';
import Column from 'primevue/column';

const sampleTableData = ref([
  { code: 'P001', name: 'Product 1', category: 'Category 1' },
  { code: 'P002', name: 'Product 2', category: 'Category 2' },
  { code: 'P003', name: 'Product 3', category: 'Category 3' },
]);
const currentUsers = ref([{ id: 123 }, { id: 456 }]);
const selectButton = ref('bg-gray-800');
const selectButtonOptions = ref(['bg-gray-700', 'bg-gray-800', 'bg-gray-900']);
const contextMenuRef = ref(null);
const showContextMenu = (event) => {
  event.preventDefault();
  contextMenuRef.value.show(event);
};
const sliderValue = ref(50);
const searchString = ref('');
const toggleSwitch = ref(false);
const radioOption = ref('option1');
const radioButtonOptions = ref([
  { label: 'Option 1', value: 'option1' },
  { label: 'Option 2', value: 'option2' },
  { label: 'Option 3', value: 'option3' },
]);
const selectionItemObjects = ref([
  { uuid: '1', type: 'bookmark', title: 'Bookmark 1' },
  { uuid: '2', type: 'comment', content: 'Comment 1' },
  {
    uuid: '3',
    type: 'bookmark',
    title: 'Bookmark 2',
    children: [
      { uuid: '3-1', type: 'bookmark', title: 'Sub Bookmark 1' },
      { uuid: '3-2', type: 'comment', content: 'Sub Comment 1' },
    ],
  },
  { uuid: '4', type: 'comment', content: 'Comment 2' },
]);

const contextItems = ref([
  {
    label: 'Option 1',
    icon: 'pi pi-sparkles',
  },
  {
    label: 'Option 2',
    icon: 'pi pi-cloud-download',
  },
  {
    icon: 'pi pi-plus',
    items: [
      {
        label: 'Sub Option 1',
        icon: 'pi pi-box',
      },
      {
        label: 'Sub Option 2',
        icon: 'pi pi-circle',
      },
      {
        label: 'Sub Option 1',
        icon: 'pi pi-box',
      },
      {
        label: 'c',
        icon: 'pi pi-circle',
        items: [
          {
            label: 'Sub Option 1',
            icon: 'pi pi-box',
          },
          {
            label: 'Sub Option 2',
            icon: 'pi pi-circle',
          },
          {
            label: 'Sub Option 1',
            icon: 'pi pi-box',
          },
          {
            label: 'cc',
            icon: 'pi pi-circle',
            items: [
              {
                label: 'Sub Option 1',
                icon: 'pi pi-box',
              },
              {
                label: 'Sub Option 2',
                icon: 'pi pi-circle',
              },
              {
                label: 'Sub Option 1',
                icon: 'pi pi-box',
              },
              {
                label: 'Sub Option 2',
                icon: 'pi pi-circle',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    icon: 'pi pi-plus',
    items: [
      {
        label: 'Sub Option 1',
        icon: 'pi pi-box',
      },
      {
        label: 'Sub Option 2',
        icon: 'pi pi-circle',
      },
    ],
  },
]);

const pixelsPerSecond = ref(5);
const timelineLength = 3600; // seconds  (prop‑ify when needed)
const rowHeight = 52; // px (matches 14rem row from SVG)
// // Add new refs for viewport calculations
const viewportStart = ref(0);
const viewportEnd = ref(timelineLength);

const tickConfig = computed(() => {
  const pps = pixelsPerSecond.value;

  if (pps < 0.1) {
    return {
      tickInterval: 60, // Show ticks every minute
      majorTickInterval: 300, // Major ticks every 5 minutes
      showLabel: (s) => s % 300 === 0, // Show labels every 5 minutes
    };
  } else if (pps < 1) {
    return {
      tickInterval: 30, // Show ticks every 30 seconds
      majorTickInterval: 60, // Major ticks every minute
      showLabel: (s) => s % 60 === 0, // Show labels every minute
    };
  } else if (pps < 4) {
    return {
      tickInterval: 5, // Show ticks every 5 seconds
      majorTickInterval: 30, // Major ticks every 30 seconds
      showLabel: (s) => s % 30 === 0, // Show labels every 30 seconds
    };
  } else if (pps < 20) {
    return {
      tickInterval: 1, // Show ticks every second
      majorTickInterval: 5, // Major ticks every 5 seconds
      showLabel: (s) => s % 5 === 0, // Show labels every 5 seconds
    };
  } else {
    return {
      tickInterval: 1, // Show ticks every second
      majorTickInterval: 1, // All ticks are major at high zoom
      showLabel: () => true, // Show all labels at high zoom
    };
  }
});

const shouldShowTick = (s) => s % tickConfig.value.tickInterval === 0;
const isMajorTick = (s) => s % tickConfig.value.majorTickInterval === 0;
const shouldShowLabel = (s) => tickConfig.value.showLabel(s);

// Calculate visible ticks based on viewport
const visibleTicks = computed(() => {
  const startSecond = Math.floor(viewportStart.value / pixelsPerSecond.value);
  const endSecond = Math.ceil(viewportEnd.value / pixelsPerSecond.value);

  // Add some padding to prevent pop-in during scroll
  const padding = 10; // seconds of padding on each side
  const start = Math.max(0, startSecond - padding);
  const end = Math.min(timelineLength, endSecond + padding);

  return Array.from({ length: end - start }, (_, i) => start + i);
});

const getLayersKeyframes = ref([
  { key: 'layer1', keyframes: [{ time: 0 }, { time: 100 }, { time: 200 }] },
  {
    key: 'layer2',
    keyframes: [{ time: 150 }, { time: 160 }, { time: 170 }],
  },
]);

const menuSelected = (event) => {
  console.log('Menu item selected:', event);
};
</script>
